export function initPricePackages() {
    document.querySelectorAll('.pricePackages').forEach((container) => {
        const topseller = container.querySelector('.pricePackage:has(.pricePackage__badge)');
        if (!topseller) return;

        // Only scroll if container is actually in scroll-snap mode (mobile)
        if (container.scrollWidth <= container.clientWidth) return;

        const scrollLeft = topseller.offsetLeft - (container.clientWidth - topseller.offsetWidth) / 2;
        setTimeout(() => {
            container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }, 300);
    });
}